import { connect } from "react-redux";

import {
  isPristine,
  isSubmitting,
  getFormValues,
  change,
  clearFields,
  reset
} from "redux-form";
//components
import { UserFormComponent } from "src/components/forms/user_form_component";

//actions
import { createUserAction, updateUserAction } from "src/actions/data_actions";

//selectors
import { partnersArraySortSelector } from "src/selectors/data_selectors";
import {
  createUserFormPartnerOrganizationsOptionsSelector,
  createUserFormFacilityOptionsSelector,
  createUserFormFacilityUnitOptionsSelector,
  selectedPartnerIdSelector,
  createUserFormDefaultFacilityOptionsSelector
} from "src/selectors/section_selectors/admin";
//Selectors
import {
  rolesResourceSelectors,
  customRolesResourceSelectors,
  usersResourceSelectors
} from "src/selectors/data_selectors";
import {
  adminPartnerDropDownEnabledSelector,
  currentUserSelector
} from "src/selectors/config_selectors";
import { userPasswordMinLengthSelector } from "src/selectors/ui_config_selectors/global";
import { reduxFormNames } from "src/constants";

function mapStateToProps(state) {
  return {
    formName: reduxFormNames.userCreateForm,
    units: createUserFormFacilityUnitOptionsSelector(
      reduxFormNames.userCreateForm
    )(state),
    facilities: createUserFormFacilityOptionsSelector(
      reduxFormNames.userCreateForm
    )(state),
    partners: partnersArraySortSelector(state),
    organizations: createUserFormPartnerOrganizationsOptionsSelector(
      reduxFormNames.userCreateForm
    )(state),
    pristine: isPristine(reduxFormNames.userCreateForm)(state),
    submitting: isSubmitting(reduxFormNames.userCreateForm)(state),
    formValues: getFormValues(reduxFormNames.userCreateForm)(state),
    roles: rolesResourceSelectors.dataSelector(state),
    customRoles: customRolesResourceSelectors.dataSelector(state),
    partnerDropDownEnabled: adminPartnerDropDownEnabledSelector(state),
    currentUser: currentUserSelector(state),
    createLoadState: usersResourceSelectors.postLoadStateSelector(state),
    selectedPartnerId: selectedPartnerIdSelector(state),
    defaultFacilities: createUserFormDefaultFacilityOptionsSelector(
      reduxFormNames.userCreateForm
    )(state),
    userPasswordMinLength: userPasswordMinLengthSelector(state)
  };
}
function mapDispatchToProps(dispatch) {
  return {
    sendCreateUserAction(payload) {
      return dispatch(createUserAction(payload));
    },
    sendUpdateUserAction(payload) {
      return dispatch(updateUserAction(payload));
    },
    resetForm() {
      return dispatch(reset(reduxFormNames.userCreateForm));
    },
    changeField(fieldName, fieldValue) {
      dispatch(change(reduxFormNames.userCreateForm, fieldName, fieldValue));
    },
    clearFields(...fieldNames) {
      dispatch(
        clearFields(reduxFormNames.userCreateForm, false, false, ...fieldNames)
      );
    }
  };
}
export const CreateUserFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserFormComponent);
